/*
 * Copyright (c) 2017 by Julian Feder, julian.feder@yahoo.de
 *
 * This product includes software developed at
 * The Apache Software Foundation (http://www.apache.org/).
 */

(function() {
    'use strict';

    angular
        .module('askApp')
        .controller('MemberBookingDialogController', MemberBookingDialogController);

    MemberBookingDialogController.$inject = ['$timeout', '$scope', '$state', '$uibModalInstance', 'ProfileService', '$http', '$sce', 'AlertService', 'entity'];

    function MemberBookingDialogController ($timeout, $scope, $state, $uibModalInstance, ProfileService, $http, $sce, AlertService, entity) {
        var vm = this;

        $scope.status = {
            descriptionOpen: false,
            conditionsOpen: false
        };

        vm.project = entity;
        vm.booking = {};
        vm.booking.projectID = vm.project.id;
        vm.booking.points = 0;
        vm.booking.individualPrice = vm.project.individualPriceBoolean;
        vm.booking.sksTheoryAvailable = false;
        vm.dataValid = vm.project.checkWeight && vm.project.checkClothingSize && vm.project.checkShoeSize && vm.project.checkNationality && vm.project.checkBirthplace && vm.project.checkCountryOfBirth && vm.project.checkIDNumber;
        vm.clear = clear;
        vm.save = save;
        vm.addData = addData;
        vm.pointsPicked = pointsPicked;
        vm.setIndividualPrice = setIndividualPrice;
        var activityPointValue;
        var originPrice = vm.project.price;

        ProfileService.getProfileInfo().then(function(response) {
            activityPointValue = response.activityPointValue;
            calcMaxPoints();
            vm.pointsPicked();
        });

        function setIndividualPrice() {
            if(vm.booking.individualPrice) {
                vm.project.price = vm.project.individualPrice;
            } else {
                vm.project.price = originPrice;
            }
            calcMaxPoints();
            vm.pointsPicked();
        }

        function calcMaxPoints () {
            var points = Math.floor(vm.project.price / activityPointValue);
            $scope.maxPoints = Math.min(vm.project.availableActivityPoints, points);
        }

        $timeout(function () {
            angular.element('.form-group:eq(0)>input').focus();
        });

        function pointsPicked () {
            var pointsValue = vm.booking.points * activityPointValue;
            $scope.price = vm.project.price - pointsValue;
            $scope.prepayment = Math.max(vm.project.prepayment - pointsValue, 0);
        }

        function addData () {
            $state.go('member.personal.additional');
            $uibModalInstance.dismiss('cancel');
        }

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            $http.post('api/member/bookings/', vm.booking).then(function(response) {
                vm.error = null;
                vm.isSaving = false;
                AlertService.success('Du hast dich erfolgreich für das Projekt <b>' + vm.project.name + '</b> angemeldet.');
                $uibModalInstance.close(response);
                vm.isSaving = false;
            }, function(error) {
                vm.isSaving = false;
            });
        }

        $scope.renderHtml = function(code) {
            return $sce.trustAsHtml(code);
        };
    }
})();
